<template>
	<div class="expert-review-settings">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">{{getPageTitle}}</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<!-- 专家评审设置主体内容 -->
										<div class="tab-content">
											<!-- 进度条 -->
											<div class="tab-pane show active" id="firstReview">
												<div class="expRevSchedule">
													<div class="progress pro-expertReview">
														<div class="progress-bar progress-bar-striped progress-bar-animated bg-success" :style="scheduleList[scheduleActive - 1].style"></div>
														<div
															class="proPoint"
															:class="{active:scheduleActive >= item.id,['proPoint'+item.id]:true,'cur-active':curShowProgress==item.id}"
															v-for="item in scheduleList"
															:key="item.id"
															@click="handleScheduleChange(item.id)"
														>
															<a>
																<i>{{ item.id }}</i>
																{{ item.name }}
															</a>
														</div>
													</div>
												</div>
												
												<!-- 基本信息 -->
												<BaseInfo @edited="baseInfoEdited" v-if="curShowProgress == 1"/>
												
												<!-- 课题分组 -->
												<TopicGroup @finish="finishTopicGroup" v-if="curShowProgress == 2" />
												<!-- 课题分组结束 -->

												<!-- 分配专家 -->
												<AllocationExpert @finish="finishAllocationExpert" v-if="curShowProgress == 3"/>

												<!-- 设置评分标椎 -->
												<SetGradingCriteria @finish="finishSetGradingCriteria" v-if="curShowProgress == 4"/>

												<!-- 开启评审打分 -->
												<div class="open-review-score" v-if="curShowProgress == 5">已开启评审打分</div>

												<!-- 查看评审进度 -->
												<ReviewProgress v-if="curShowProgress == 6"/>

												<!-- 查看评审结果 -->
												<ReviewResult v-if="curShowProgress == 7"/>
												<!-- 结束 -->
												<div class="end" v-if="curShowProgress == 8">专家评审已经结束！</div>
											</div>
											<div class="tab-pane" id="secondReview"></div>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getBaseInfoDetail } from '@/api/after/topicManage.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue'
import BaseInfo from './components/BaseInfo.vue'
import TopicGroup from './components/TopicGroup.vue'
import AllocationExpert from './components/AllocationExpert.vue'
import SetGradingCriteria from './components/SetGradingCriteria.vue'
import ReviewProgress from './components/ReviewProgress.vue'
import ReviewResult from './components/ReviewResult.vue'
export default {
	components:{
		Breadcrumb,
		BaseInfo,
		TopicGroup,
		AllocationExpert,
		SetGradingCriteria,
		ReviewProgress,
		ReviewResult
	},
	computed:{
		// 获取页面标题
		getPageTitle(){
			if (this.reviewBaseInfo) {
				if (this.reviewBaseInfo.reviewType == 0) {
					return '专家初审'
				}else if (this.reviewBaseInfo.reviewType == 1) {
					return '专家复审'
				}else{
					return '专家终审'
				}
			}
			
		}
	},
	data() {
		return {
			scheduleActive: 6, //当前进度条
			curShowProgress:1,//当前显示进度
			scheduleList: [
				{ id: 1, name: '评价基本信息', style: 'width:0%;' },
				{ id: 2, name: '课题分组', style: 'width:14.28%;' },
				{ id: 3, name: '分配专家', style: 'width:28.56%;' },
				{ id: 4, name: '设置评分标椎', style: 'width:42.84%;' },
				{ id: 5, name: '开启评审打分', style: 'width:57.12%;' },
				{ id: 6, name: '查看评审进度', style: 'width:71.4%;' },
				{ id: 7, name: '查看评审结果', style: 'width:85.68%;' },
				{ id: 8, name: '结束', style: 'width:100%;' }
			],
			query: {
				pageNumber: 1,
				pageSize: 10,
				pageSorts: [{ asc: true, column: '' }]
			},
			reviewBaseInfo:null,//基本评审信息
		};
	},
	async created() {
		let query = this.$route.query
		if (query.reviewId) {
			await this.getBaseInfoDetail(query.reviewId)
			this.goProgressByReviewState()
		}else{
			this.$message({
				type:'error',
				message:'参数错误!',
				onClose:()=>{
					this.$router.go(-1)
				}
			})
		}
		
	},
	methods: {
		// 基本信息修改完成
		baseInfoEdited(){
			this.scheduleActive = 2
			this.curShowProgress = 2
			this.getBaseInfoDetail(this.$route.query.reviewId)
		},
		// 课题分组完成
		finishTopicGroup(){
			this.scheduleActive = 3
			this.curShowProgress = 3
		},
		// 分配专家
		finishAllocationExpert(){
			this.scheduleActive = 4
			this.curShowProgress = 4
		},
		// 设置评分标准
		finishSetGradingCriteria(){
			this.scheduleActive = 7
			this.curShowProgress = 7
		},
		// 点击进度改变
		handleScheduleChange(index) {
			// this.scheduleActive = index;
			this.curShowProgress = index
		},
		// 根据评审ID获取评审基本信息
		async getBaseInfoDetail(id){
			const res = await getBaseInfoDetail(id)
			console.log('基本信息',res);
			if (res.code==200) {
				this.reviewBaseInfo = res.data
			}else{
				this.$message.error(res.data)
			}
		},
		// 根据评审状态跳转进程
		goProgressByReviewState(){
			switch(this.reviewBaseInfo.reviewState){
			  case 1:
					this.scheduleActive = 1
					this.curShowProgress = 1
					break;
				case 2:
					this.scheduleActive = 3
					this.curShowProgress = 3
					break;
				case 3:
					this.scheduleActive = 4
					this.curShowProgress = 4
					break;
				case 4:
					this.scheduleActive = 6
					this.curShowProgress = 6
					break;
				case 6:
					this.scheduleActive = 7
					this.curShowProgress = 7
					break;
				case 7:
					this.scheduleActive = 8
					this.curShowProgress = 8
					break;
				default:
					this.scheduleActive = 7
					this.curShowProgress = 7
			}
		}
	}
};
</script>

<style scoped lang="scss">
	.open-review-score,
	.end{
		text-align: center;
	}
	.proPoint.cur-active i{
		background-color: #0080c0;
		color: #fff;
	}
</style>
